/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SuspensionQuantity model module.
 * @module model/SuspensionQuantity
 * @version 0.0.1
 */
class SuspensionQuantity {
    /**
     * Constructs a new <code>SuspensionQuantity</code>.
     * @alias module:model/SuspensionQuantity
     */
    constructor() { 
        
        SuspensionQuantity.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SuspensionQuantity</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SuspensionQuantity} obj Optional instance to populate.
     * @return {module:model/SuspensionQuantity} The populated <code>SuspensionQuantity</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SuspensionQuantity();

            if (data.hasOwnProperty('innerPartNumber')) {
                obj['innerPartNumber'] = ApiClient.convertToType(data['innerPartNumber'], 'String');
            }
            if (data.hasOwnProperty('outerPartNumber')) {
                obj['outerPartNumber'] = ApiClient.convertToType(data['outerPartNumber'], 'String');
            }
            if (data.hasOwnProperty('feedLeftInner')) {
                obj['feedLeftInner'] = ApiClient.convertToType(data['feedLeftInner'], 'Number');
            }
            if (data.hasOwnProperty('feedLeftOuter')) {
                obj['feedLeftOuter'] = ApiClient.convertToType(data['feedLeftOuter'], 'Number');
            }
            if (data.hasOwnProperty('feedRightInner')) {
                obj['feedRightInner'] = ApiClient.convertToType(data['feedRightInner'], 'Number');
            }
            if (data.hasOwnProperty('feedRightOuter')) {
                obj['feedRightOuter'] = ApiClient.convertToType(data['feedRightOuter'], 'Number');
            }
            if (data.hasOwnProperty('dischargeLeftInner')) {
                obj['dischargeLeftInner'] = ApiClient.convertToType(data['dischargeLeftInner'], 'Number');
            }
            if (data.hasOwnProperty('dischargeLeftOuter')) {
                obj['dischargeLeftOuter'] = ApiClient.convertToType(data['dischargeLeftOuter'], 'Number');
            }
            if (data.hasOwnProperty('dischargeRightInner')) {
                obj['dischargeRightInner'] = ApiClient.convertToType(data['dischargeRightInner'], 'Number');
            }
            if (data.hasOwnProperty('dischargeRightOuter')) {
                obj['dischargeRightOuter'] = ApiClient.convertToType(data['dischargeRightOuter'], 'Number');
            }
            if (data.hasOwnProperty('feedPredictedCompressedSpringHeight')) {
                obj['feedPredictedCompressedSpringHeight'] = ApiClient.convertToType(data['feedPredictedCompressedSpringHeight'], 'Number');
            }
            if (data.hasOwnProperty('dischargePredictedCompressedSpringHeight')) {
                obj['dischargePredictedCompressedSpringHeight'] = ApiClient.convertToType(data['dischargePredictedCompressedSpringHeight'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SuspensionQuantity</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SuspensionQuantity</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['innerPartNumber'] && !(typeof data['innerPartNumber'] === 'string' || data['innerPartNumber'] instanceof String)) {
            throw new Error("Expected the field `innerPartNumber` to be a primitive type in the JSON string but got " + data['innerPartNumber']);
        }
        // ensure the json data is a string
        if (data['outerPartNumber'] && !(typeof data['outerPartNumber'] === 'string' || data['outerPartNumber'] instanceof String)) {
            throw new Error("Expected the field `outerPartNumber` to be a primitive type in the JSON string but got " + data['outerPartNumber']);
        }

        return true;
    }


}



/**
 * Part number of inner suspensions (same for all inner positions)
 * @member {String} innerPartNumber
 */
SuspensionQuantity.prototype['innerPartNumber'] = undefined;

/**
 * Part number of outer suspensions (same for all outer positions)
 * @member {String} outerPartNumber
 */
SuspensionQuantity.prototype['outerPartNumber'] = undefined;

/**
 * Quantity of inner suspensions on the feed left corner
 * @member {Number} feedLeftInner
 */
SuspensionQuantity.prototype['feedLeftInner'] = undefined;

/**
 * Quantity of outer suspensions on the feed left corner
 * @member {Number} feedLeftOuter
 */
SuspensionQuantity.prototype['feedLeftOuter'] = undefined;

/**
 * Quantity of inner suspensions on the feed right corner
 * @member {Number} feedRightInner
 */
SuspensionQuantity.prototype['feedRightInner'] = undefined;

/**
 * Quantity of outer suspensions on the feed right corner
 * @member {Number} feedRightOuter
 */
SuspensionQuantity.prototype['feedRightOuter'] = undefined;

/**
 * Quantity of inner suspensions on the discharge left corner
 * @member {Number} dischargeLeftInner
 */
SuspensionQuantity.prototype['dischargeLeftInner'] = undefined;

/**
 * Quantity of outer suspensions on the discharge left corner
 * @member {Number} dischargeLeftOuter
 */
SuspensionQuantity.prototype['dischargeLeftOuter'] = undefined;

/**
 * Quantity of inner suspensions on the discharge right corner
 * @member {Number} dischargeRightInner
 */
SuspensionQuantity.prototype['dischargeRightInner'] = undefined;

/**
 * Quantity of outer suspensions on the discharge right corner
 * @member {Number} dischargeRightOuter
 */
SuspensionQuantity.prototype['dischargeRightOuter'] = undefined;

/**
 * Predicted compressed spring height at the feed positions (mm)
 * @member {Number} feedPredictedCompressedSpringHeight
 */
SuspensionQuantity.prototype['feedPredictedCompressedSpringHeight'] = undefined;

/**
 * Predicted compressed spring height at the discharge positions (mm)
 * @member {Number} dischargePredictedCompressedSpringHeight
 */
SuspensionQuantity.prototype['dischargePredictedCompressedSpringHeight'] = undefined;






export default SuspensionQuantity;

